import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNotificationFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10 4C10 4.4566 10.1478 4.87379 10.414 5.21245C7.87187 5.90913 6 8.23885 6 11V14L4 18H20L18 14V11C18 8.23885 16.1281 5.90913 13.586 5.21245C13.8522 4.87379 14 4.4566 14 4C14 2.9 13.1 2 12 2C10.9 2 10 2.9 10 4ZM9.5 19.5C9.5 19.3988 9.5062 19.2987 9.51819 19.2H10H14H14.4818C14.4938 19.2987 14.5 19.3988 14.5 19.5C14.5 20.88 13.38 22 12 22C10.62 22 9.5 20.88 9.5 19.5Z",
		fill: "currentColor"
	})
});
export default SvgNotificationFilled;
